<template>
    <main class="lymphomap_main">
        <section class="lymphomap_auth_main">
            <div class="lymphomap_home_content_wrp">
                <div class="oncology_well_slider">
                    <div class="oncology_wel_popup">
                        <div class="oncology_wel_popup_inner">
                            <div class="oncology_wel_popup_animation">
                                <div class="oncology_wel_lange_img">
                                    <img :src="randomImg" alt="" class="img-fluid animation_start">
                                    <img :src="animationImg" alt="" class="img-fluid d-none animation_stop">
                                </div>
                                <div class="oncology_wel_line_crub">
                                    <div class="oncology_wel_left_line_crub">
                                        <img src="@/assets/images/full_line_shape.png" alt="" class="img-fluid">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="oncology_well_new">
                        <div class="oncology_well_new_img">
                            <img src="@/assets/images/slide_img.png" class="img-fluid">
                        </div>
                    </div>
                </div>
                <div class="landing_right_sidebar" v-click-outside="hideMenusPopup" v-if="!isMobile">
                    <div class="menuburger_f_sidebar">
                        <button class="btn btn-primary" @click="actvSidebar = !actvSidebar"><i aria-hidden="true"
                                class="fa fa-bars"></i></button>
                    </div>
                    <div class="r_sidebar_box" :class="{ 'active': actvSidebar }">
                        <ul class="r_sidebar_menus">
                            <li class="r_sidebar_item">
                                <router-link :to="{ name: 'AboutUsMainPage' }">
                                    <span class="r_sidebar_icon">
                                        <svg xmlns="http://www.w3.org/2000/svg"
                                            xmlns:xlink="http://www.w3.org/1999/xlink"
                                            xmlns:svgjs="http://svgjs.com/svgjs" version="1.1" width="32" height="32"
                                            x="0" y="0" viewBox="0 0 330 330" xml:space="preserve">
                                            <g>
                                                <g xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M165,0C74.019,0,0,74.02,0,165.001C0,255.982,74.019,330,165,330s165-74.018,165-164.999C330,74.02,255.981,0,165,0z    M165,300c-74.44,0-135-60.56-135-134.999C30,90.562,90.56,30,165,30s135,60.562,135,135.001C300,239.44,239.439,300,165,300z"
                                                        fill="#ffc107" data-original="#000000"></path>
                                                    <path
                                                        d="M164.998,70c-11.026,0-19.996,8.976-19.996,20.009c0,11.023,8.97,19.991,19.996,19.991   c11.026,0,19.996-8.968,19.996-19.991C184.994,78.976,176.024,70,164.998,70z"
                                                        fill="#ffc107" data-original="#000000"></path>
                                                    <path
                                                        d="M165,140c-8.284,0-15,6.716-15,15v90c0,8.284,6.716,15,15,15c8.284,0,15-6.716,15-15v-90C180,146.716,173.284,140,165,140z   "
                                                        fill="#ffc107" data-original="#000000"></path>
                                                </g>
                                                <g xmlns="http://www.w3.org/2000/svg"></g>
                                                <g xmlns="http://www.w3.org/2000/svg"></g>
                                                <g xmlns="http://www.w3.org/2000/svg"></g>
                                                <g xmlns="http://www.w3.org/2000/svg"></g>
                                                <g xmlns="http://www.w3.org/2000/svg"></g>
                                                <g xmlns="http://www.w3.org/2000/svg"></g>
                                                <g xmlns="http://www.w3.org/2000/svg"></g>
                                                <g xmlns="http://www.w3.org/2000/svg"></g>
                                                <g xmlns="http://www.w3.org/2000/svg"></g>
                                                <g xmlns="http://www.w3.org/2000/svg"></g>
                                                <g xmlns="http://www.w3.org/2000/svg"></g>
                                                <g xmlns="http://www.w3.org/2000/svg"></g>
                                                <g xmlns="http://www.w3.org/2000/svg"></g>
                                                <g xmlns="http://www.w3.org/2000/svg"></g>
                                                <g xmlns="http://www.w3.org/2000/svg"></g>
                                            </g>
                                        </svg>
                                    </span>
                                    <span class="r_sidebar_text">About Us</span>
                                </router-link>
                            </li>
                            <li class="r_sidebar_item">
                                <router-link :to="{ name: 'ourServices' }">
                                    <span class="r_sidebar_icon">
                                        <i aria-hidden="true" class="fa fa-cogs" style="font-size:28px;"></i>
                                    </span>
                                    <span class="r_sidebar_text">Our Services</span>
                                </router-link>
                            </li>
                            <li class="r_sidebar_item">
                                <router-link :to="{ name: 'cancerClassificationPage' }">
                                    <span class="r_sidebar_icon">
                                        <svg xmlns="http://www.w3.org/2000/svg"
                                            xmlns:xlink="http://www.w3.org/1999/xlink"
                                            xmlns:svgjs="http://svgjs.com/svgjs" version="1.1" width="36" height="36"
                                            x="0" y="0" viewBox="0 0 124 124" style="enable-background:new 0 0 44 44"
                                            xml:space="preserve" class="">
                                            <g>
                                                <path xmlns="http://www.w3.org/2000/svg" id="XMLID_198_"
                                                    d="m106.435 36.212h-6.002l-3.331 3.317-3.471 8.843-13.358 11.844 6.27 4.011 15.991-9.687 5.103-15.011z"
                                                    fill="#ffc107" data-original="#fccb89" />
                                                <path xmlns="http://www.w3.org/2000/svg" id="XMLID_552_"
                                                    d="m107.637 39.529c6.438-3.203 9.091-11.151 8.378-17.926-.665-6.313-4.46-12.807-11.015-14.293-3.31-.751-6.765.038-9.468 2.078-1.342 1.013-.993 3.179.584 3.734 4.101 1.444 6.965 6.462 6.965 12.205 0 1.483-.197 2.928-.562 4.283-2.618-1.389-4.446-4.076-5.175-6.909-.192-.747-.224-3.85-.375-4.612-.278-1.4-1.802-2.15-3.084-1.436-4.896 2.726-5.795 9.214-4.193 14.125 1.64 5.03 5.746 9.137 11.113 9.803 3.265.404 5.788-.577 6.832-1.052 1.755-.874-1.044.475 0 0 6.438-3.204-1.044.475 0 0z"
                                                    fill="#ffc107" data-original="#f05072" class="" />
                                                <path xmlns="http://www.w3.org/2000/svg" id="XMLID_202_"
                                                    d="m32.975 51.223 14.001 6.376-6.381 8.135-19.087-9.906-6.15-19.798 10.213-.861z"
                                                    fill="#ffc107" data-original="#fccb89" />
                                                <path xmlns="http://www.w3.org/2000/svg" id="XMLID_551_"
                                                    d="m29.211 38.214c3.537-2.757 5.767-7.226 5.888-11.706.104-3.846-1.449-7.911-4.942-9.856-1.514-.843-3.424.433-3.189 2.161.564 4.144-1.728 8.824-5.445 10.796-1.538-5.718.094-14.267 6.403-16.488 1.578-.555 1.925-2.721.584-3.734-4.276-3.229-10.033-3.176-14.248.117-4.306 3.364-6.351 8.991-6.351 14.336 0 8.5 5.796 17.868 15.281 16.74 3.001-.357 5.089-1.687 6.019-2.366 1.796-1.4-.93.679 0 0 3.538-2.757-.93.679 0 0z"
                                                    fill="#ffc107" data-original="#f05072" class="" />
                                                <path xmlns="http://www.w3.org/2000/svg" id="XMLID_206_"
                                                    d="m54.024 51.906c-.542 0-1.082-.219-1.476-.65l-4.09-4.469c-.746-.815-.69-2.081.124-2.827.815-.747 2.081-.69 2.825.125l4.09 4.469c1.147 1.251.231 3.352-1.473 3.352z"
                                                    fill="#ffc107" data-original="#fccb89" />
                                                <circle xmlns="http://www.w3.org/2000/svg" id="XMLID_208_" cx="48.088"
                                                    cy="42.109" fill="#ffc107" r="4.501" data-original="#a2d9af"
                                                    class="" />
                                                <path xmlns="http://www.w3.org/2000/svg" id="XMLID_211_"
                                                    d="m73.235 51.906c-1.704 0-2.619-2.1-1.475-3.352l4.089-4.469c.746-.815 2.012-.872 2.826-.125.814.746.87 2.012.125 2.827l-4.089 4.469c-.394.431-.934.65-1.476.65z"
                                                    fill="#ffc107" data-original="#fccb89" />
                                                <circle xmlns="http://www.w3.org/2000/svg" id="XMLID_553_" cx="79.17"
                                                    cy="42.109" fill="#ffc107" r="4.501" data-original="#a2d9af"
                                                    class="" />
                                                <g xmlns="http://www.w3.org/2000/svg" fill="#fccb89">
                                                    <path id="XMLID_214_"
                                                        d="m1.994 100.044c-1.457 0-2.431-1.573-1.796-2.877l7.5-15.407c.283-.581.829-.99 1.467-1.097l19.224-3.232c1.088-.186 2.121.552 2.304 1.641.183 1.09-.552 2.122-1.642 2.305l-18.208 3.062-7.049 14.48c-.346.711-1.059 1.125-1.8 1.125z"
                                                        fill="#ffc107" data-original="#fccb89" />
                                                    <path id="XMLID_216_"
                                                        d="m24.258 117c-.917 0-1.743-.635-1.95-1.567l-2.751-12.37c-.175-.787.139-1.602.796-2.068l14.847-10.52c.903-.639 2.151-.425 2.788.477.639.902.426 2.15-.476 2.789l-13.762 9.751 2.462 11.071c.274 1.233-.693 2.437-1.954 2.437z"
                                                        fill="#ffc107" data-original="#fccb89" />
                                                    <path id="XMLID_218_"
                                                        d="m122.002 98.745c-.834 0-1.612-.526-1.895-1.36l-5.503-16.26-18.655-3.933c-1.081-.228-1.773-1.289-1.545-2.371.228-1.081 1.29-1.773 2.369-1.545l19.772 4.169c.692.146 1.256.646 1.483 1.316l5.869 17.34c.431 1.276-.544 2.644-1.895 2.644z"
                                                        fill="#ffc107" data-original="#fccb89" />
                                                    <path id="XMLID_220_"
                                                        d="m100.807 117c-1.237 0-2.199-1.162-1.967-2.376l1.931-10.127-13.272-11.331c-.841-.718-.94-1.98-.224-2.821.716-.84 1.981-.941 2.819-.223l14.157 12.085c.547.467.802 1.191.667 1.897l-2.149 11.27c-.181.958-1.02 1.626-1.962 1.626z"
                                                        fill="#ffc107" data-original="#fccb89" />
                                                    <ellipse id="XMLID_222_" cx="62.324" cy="75.235" rx="34.037"
                                                        ry="26.113" fill="#ffc107" data-original="#fccb89" />
                                                </g>
                                            </g>
                                        </svg>
                                    </span>
                                    <span class="r_sidebar_text">AI Cancer Classifier</span>
                                </router-link>
                            </li>
                            <li class="r_sidebar_item">
                                <router-link :to="{ name: 'membershipPackages' }">
                                    <span class="r_sidebar_icon">
                                        <img src="@/assets/images/subscription_package_yellow.png"
                                            class="img-fluid normal_view_icon" width="20">
                                    </span>
                                    <span class="r_sidebar_text">Packages</span>
                                </router-link>
                            </li>
                            <li class="r_sidebar_item">
                                <router-link :to="{ name: 'ourApp' }">
                                    <span class="r_sidebar_icon">
                                        <i aria-hidden="true" class="fa fa-mobile" style="font-size: 40px;"></i>
                                    </span>
                                    <span class="r_sidebar_text">Our App</span>
                                </router-link>
                            </li>
                            <li class="r_sidebar_item">
                                <router-link :to="{ name: 'allEventList' }">
                                    <span class="r_sidebar_icon">
                                        <i aria-hidden="true" class="fa fa-calendar" style="font-size:26px;"></i>
                                    </span>
                                    <span class="r_sidebar_text">Our Events</span>
                                </router-link>
                            </li>
                            <li class="r_sidebar_item">
                                <router-link :to="{ name: 'publicVistaMedia' }">
                                    <span class="r_sidebar_icon">
                                        <img src="@/assets/images/vista_eye_yellow.gif" class="img-fluid normal_view_icon"
                                            width="38">
                                    </span>
                                    <span class="r_sidebar_text">Vista</span>
                                </router-link>
                            </li>
                            <li class="r_sidebar_item">
                                <router-link :to="{ name: 'faqPage' }">
                                    <span class="r_sidebar_icon">
                                       <i class="fa fa-quora" aria-hidden="true" style="font-size:24px;"></i>
                                    </span>
                                    <span class="r_sidebar_text">FAQ</span>
                                </router-link>
                            </li>
                            <li class="r_sidebar_item">
                                <router-link :to="{ name: 'LbilInfoPage' }">
                                    <span class="r_sidebar_icon">
                                        <img src="@/assets/images/lbil_yellow.png" class="img-fluid normal_view_icon"
                                            width="22">
                                    </span>
                                    <span class="r_sidebar_text">LBIL</span>
                                </router-link>
                            </li>
                        </ul>
                    </div>
                </div>
                <!-- Sign Up Popup Code Here -->
                <sign-up v-if="signUpFormEnabled"></sign-up>
                <!-- Sign Up Popup Code Here -->
                <template v-if="!isMobile">
                    <label class="request_for_demo_label_fixed slide_actv d-none" @click="movePrev">Register For
                        Demo</label>
                    <label class="request_for_demo_label_fixed default_actv" :class="actvSlide ? 'active' : ''"
                        @click="moveNext">Register For Demo</label>
                    <pahs-banner-info></pahs-banner-info>
                </template>
            </div>
            <div class="fullpage-container" v-if="!isMobile">
                <div class="fullpage-wp" v-fullpage="opts" ref="example">
                    <section class="section login_form_section">
                        <div class="oncology_well_form" v-if="safariBlockedCookiesState">
                            <div class="more_info_add" id="authBtnFDesk">
                                <a href="javascript:void(0)" class="more_info_add_btn"
                                    @click="blockedCookiesPopupState = true">Login</a>
                                <a href="javascript:void(0)" class="sign_up_btn ml-4"
                                    @click="blockedCookiesPopupState = true">Sign<span
                                        style="margin-left:3px;">Up</span></a>
                            </div>
                        </div>
                        <div class="oncology_well_form" v-if="authCheckLabelState">
                            <div class="more_info_add" id="authBtnFDesk">
                                <template v-if="authBtnShowState">
                                    <a href="javascript:void(0)" class="more_info_add_btn"
                                        @click="loginFormShowMethod">Login</a>
                                    <a href="javascript:void(0)" class="sign_up_btn ml-4"
                                        @click="signUpFormShow">Sign<span style="margin-left:3px;">Up</span></a>
                                </template>
                            </div>
                            <!-- login form code here -->
                            <main-login-form-popup v-if="mainLoginFormPopupState"></main-login-form-popup>
                            <!-- login form code here -->
                        </div>
                    </section>
                    <section class="section request_for_demo_section_main">
                        <request-for-demo-popup></request-for-demo-popup>
                    </section>
                    <section class="section tukivita_section">
                        <tukivita-info-section></tukivita-info-section>
                    </section>
                    <section class="section project_collaboration_section">
                        <project-collaboration-list></project-collaboration-list>
                    </section>
                    <section class="section vista_screen_linkage">
                        <vista-linkage-screen></vista-linkage-screen>
                    </section>
                    <section class="section">
                        <our-past-event-screen></our-past-event-screen>
                    </section>
                </div>
            </div>
            <div class="full_section_in_mbl" v-else>
                <section class="login_form_section">
                    <div class="oncology_well_form">
                        <div class="landing_page_linkage_option">
                            <div class="landing_page_linkage_item">
                                <div class="landing_page_linkage_box">
                                    <router-link :to="{ name: 'AboutUsMainPage' }">
                                        <span class="linkage_box_icon">
                                            <svg xmlns="http://www.w3.org/2000/svg"
                                                xmlns:xlink="http://www.w3.org/1999/xlink"
                                                xmlns:svgjs="http://svgjs.com/svgjs" version="1.1" width="32"
                                                height="32" x="0" y="0" viewBox="0 0 330 330" xml:space="preserve">
                                                <g>
                                                    <g xmlns="http://www.w3.org/2000/svg">
                                                        <path
                                                            d="M165,0C74.019,0,0,74.02,0,165.001C0,255.982,74.019,330,165,330s165-74.018,165-164.999C330,74.02,255.981,0,165,0z    M165,300c-74.44,0-135-60.56-135-134.999C30,90.562,90.56,30,165,30s135,60.562,135,135.001C300,239.44,239.439,300,165,300z"
                                                            fill="#ffc107" data-original="#000000"></path>
                                                        <path
                                                            d="M164.998,70c-11.026,0-19.996,8.976-19.996,20.009c0,11.023,8.97,19.991,19.996,19.991   c11.026,0,19.996-8.968,19.996-19.991C184.994,78.976,176.024,70,164.998,70z"
                                                            fill="#ffc107" data-original="#000000"></path>
                                                        <path
                                                            d="M165,140c-8.284,0-15,6.716-15,15v90c0,8.284,6.716,15,15,15c8.284,0,15-6.716,15-15v-90C180,146.716,173.284,140,165,140z   "
                                                            fill="#ffc107" data-original="#000000"></path>
                                                    </g>
                                                    <g xmlns="http://www.w3.org/2000/svg"></g>
                                                    <g xmlns="http://www.w3.org/2000/svg"></g>
                                                    <g xmlns="http://www.w3.org/2000/svg"></g>
                                                    <g xmlns="http://www.w3.org/2000/svg"></g>
                                                    <g xmlns="http://www.w3.org/2000/svg"></g>
                                                    <g xmlns="http://www.w3.org/2000/svg"></g>
                                                    <g xmlns="http://www.w3.org/2000/svg"></g>
                                                    <g xmlns="http://www.w3.org/2000/svg"></g>
                                                    <g xmlns="http://www.w3.org/2000/svg"></g>
                                                    <g xmlns="http://www.w3.org/2000/svg"></g>
                                                    <g xmlns="http://www.w3.org/2000/svg"></g>
                                                    <g xmlns="http://www.w3.org/2000/svg"></g>
                                                    <g xmlns="http://www.w3.org/2000/svg"></g>
                                                    <g xmlns="http://www.w3.org/2000/svg"></g>
                                                    <g xmlns="http://www.w3.org/2000/svg"></g>
                                                </g>
                                            </svg>
                                        </span>
                                        <span class="linkage_box_title">About Us</span>
                                    </router-link>
                                </div>
                                <div class="landing_page_linkage_box">
                                    <router-link :to="{ name: 'ourServices' }">
                                        <span class="linkage_box_icon">
                                          <i aria-hidden="true" class="fa fa-cogs" style="font-size:28px;"></i>
                                        </span>
                                        <span class="linkage_box_title">Our Services</span>
                                    </router-link>
                                </div>
                                <div class="landing_page_linkage_box">
                                    <router-link :to="{ name: 'cancerClassificationPage' }">
                                        <span class="linkage_box_icon"><svg xmlns="http://www.w3.org/2000/svg"
                                                xmlns:xlink="http://www.w3.org/1999/xlink"
                                                xmlns:svgjs="http://svgjs.com/svgjs" version="1.1" width="44"
                                                height="44" x="0" y="0" viewBox="0 0 124 124" xml:space="preserve">
                                                <g>
                                                    <path xmlns="http://www.w3.org/2000/svg" id="XMLID_198_"
                                                        d="m106.435 36.212h-6.002l-3.331 3.317-3.471 8.843-13.358 11.844 6.27 4.011 15.991-9.687 5.103-15.011z"
                                                        fill="#ffc107" data-original="#fccb89"></path>
                                                    <path xmlns="http://www.w3.org/2000/svg" id="XMLID_552_"
                                                        d="m107.637 39.529c6.438-3.203 9.091-11.151 8.378-17.926-.665-6.313-4.46-12.807-11.015-14.293-3.31-.751-6.765.038-9.468 2.078-1.342 1.013-.993 3.179.584 3.734 4.101 1.444 6.965 6.462 6.965 12.205 0 1.483-.197 2.928-.562 4.283-2.618-1.389-4.446-4.076-5.175-6.909-.192-.747-.224-3.85-.375-4.612-.278-1.4-1.802-2.15-3.084-1.436-4.896 2.726-5.795 9.214-4.193 14.125 1.64 5.03 5.746 9.137 11.113 9.803 3.265.404 5.788-.577 6.832-1.052 1.755-.874-1.044.475 0 0 6.438-3.204-1.044.475 0 0z"
                                                        fill="#ffc107" data-original="#f05072"></path>
                                                    <path xmlns="http://www.w3.org/2000/svg" id="XMLID_202_"
                                                        d="m32.975 51.223 14.001 6.376-6.381 8.135-19.087-9.906-6.15-19.798 10.213-.861z"
                                                        fill="#ffc107" data-original="#fccb89"></path>
                                                    <path xmlns="http://www.w3.org/2000/svg" id="XMLID_551_"
                                                        d="m29.211 38.214c3.537-2.757 5.767-7.226 5.888-11.706.104-3.846-1.449-7.911-4.942-9.856-1.514-.843-3.424.433-3.189 2.161.564 4.144-1.728 8.824-5.445 10.796-1.538-5.718.094-14.267 6.403-16.488 1.578-.555 1.925-2.721.584-3.734-4.276-3.229-10.033-3.176-14.248.117-4.306 3.364-6.351 8.991-6.351 14.336 0 8.5 5.796 17.868 15.281 16.74 3.001-.357 5.089-1.687 6.019-2.366 1.796-1.4-.93.679 0 0 3.538-2.757-.93.679 0 0z"
                                                        fill="#ffc107" data-original="#f05072"></path>
                                                    <path xmlns="http://www.w3.org/2000/svg" id="XMLID_206_"
                                                        d="m54.024 51.906c-.542 0-1.082-.219-1.476-.65l-4.09-4.469c-.746-.815-.69-2.081.124-2.827.815-.747 2.081-.69 2.825.125l4.09 4.469c1.147 1.251.231 3.352-1.473 3.352z"
                                                        fill="#ffc107" data-original="#fccb89"></path>
                                                    <circle xmlns="http://www.w3.org/2000/svg" id="XMLID_208_"
                                                        cx="48.088" cy="42.109" fill="#ffc107" r="4.501"
                                                        data-original="#a2d9af"></circle>
                                                    <path xmlns="http://www.w3.org/2000/svg" id="XMLID_211_"
                                                        d="m73.235 51.906c-1.704 0-2.619-2.1-1.475-3.352l4.089-4.469c.746-.815 2.012-.872 2.826-.125.814.746.87 2.012.125 2.827l-4.089 4.469c-.394.431-.934.65-1.476.65z"
                                                        fill="#ffc107" data-original="#fccb89"></path>
                                                    <circle xmlns="http://www.w3.org/2000/svg" id="XMLID_553_"
                                                        cx="79.17" cy="42.109" fill="#ffc107" r="4.501"
                                                        data-original="#a2d9af"></circle>
                                                    <g xmlns="http://www.w3.org/2000/svg" fill="#fccb89">
                                                        <path id="XMLID_214_"
                                                            d="m1.994 100.044c-1.457 0-2.431-1.573-1.796-2.877l7.5-15.407c.283-.581.829-.99 1.467-1.097l19.224-3.232c1.088-.186 2.121.552 2.304 1.641.183 1.09-.552 2.122-1.642 2.305l-18.208 3.062-7.049 14.48c-.346.711-1.059 1.125-1.8 1.125z"
                                                            fill="#ffc107" data-original="#fccb89"></path>
                                                        <path id="XMLID_216_"
                                                            d="m24.258 117c-.917 0-1.743-.635-1.95-1.567l-2.751-12.37c-.175-.787.139-1.602.796-2.068l14.847-10.52c.903-.639 2.151-.425 2.788.477.639.902.426 2.15-.476 2.789l-13.762 9.751 2.462 11.071c.274 1.233-.693 2.437-1.954 2.437z"
                                                            fill="#ffc107" data-original="#fccb89"></path>
                                                        <path id="XMLID_218_"
                                                            d="m122.002 98.745c-.834 0-1.612-.526-1.895-1.36l-5.503-16.26-18.655-3.933c-1.081-.228-1.773-1.289-1.545-2.371.228-1.081 1.29-1.773 2.369-1.545l19.772 4.169c.692.146 1.256.646 1.483 1.316l5.869 17.34c.431 1.276-.544 2.644-1.895 2.644z"
                                                            fill="#ffc107" data-original="#fccb89"></path>
                                                        <path id="XMLID_220_"
                                                            d="m100.807 117c-1.237 0-2.199-1.162-1.967-2.376l1.931-10.127-13.272-11.331c-.841-.718-.94-1.98-.224-2.821.716-.84 1.981-.941 2.819-.223l14.157 12.085c.547.467.802 1.191.667 1.897l-2.149 11.27c-.181.958-1.02 1.626-1.962 1.626z"
                                                            fill="#ffc107" data-original="#fccb89"></path>
                                                        <ellipse id="XMLID_222_" cx="62.324" cy="75.235" rx="34.037"
                                                            ry="26.113" fill="#ffc107" data-original="#fccb89">
                                                        </ellipse>
                                                    </g>
                                                </g>
                                            </svg>
                                        </span>
                                        <span class="linkage_box_title">AI Cancer Classifier</span>
                                    </router-link>
                                </div>
                                <div class="landing_page_linkage_box">
                                    <router-link :to="{ name: 'membershipPackages' }">
                                        <span class="linkage_box_icon">
                                            <img src="@/assets/images/subscription_package_yellow.png"
                                                class="img-fluid normal_view_icon" width="22">
                                        </span>
                                        <span class="linkage_box_title">Packages</span>
                                    </router-link>
                                </div>
                                <div class="landing_page_linkage_box">
                                    <router-link :to="{ name: 'ourApp' }">
                                        <span class="linkage_box_icon">
                                            <i aria-hidden="true" class="fa fa-mobile"></i>
                                        </span>
                                        <span class="linkage_box_title">Our App</span>
                                    </router-link>
                                </div>
                                <div class="landing_page_linkage_box">
                                    <router-link :to="{ name: 'allEventList' }">
                                        <span class="linkage_box_icon">
                                            <i aria-hidden="true" class="fa fa-calendar" style="font-size:32px;"></i>
                                        </span>
                                        <span class="linkage_box_title">Our Events</span>
                                    </router-link>
                                </div>
                                <div class="landing_page_linkage_box">
                                    <router-link :to="{ name: 'publicVistaMedia' }">
                                        <span class="linkage_box_icon">
                                            <img src="@/assets/images/vista_eye_yellow.gif"
                                                class="img-fluid normal_view_icon" width="58">
                                        </span>
                                        <span class="linkage_box_title">Vista</span>
                                    </router-link>
                                </div>
                                <div class="landing_page_linkage_box">
                                    <router-link :to="{ name: 'LbilInfoPage' }">
                                        <span class="linkage_box_icon">
                                            <img src="@/assets/images/lbil_yellow.png"
                                                class="img-fluid normal_view_icon" width="22">
                                        </span>
                                        <span class="linkage_box_title">LBIL</span>
                                    </router-link>
                                </div>
                            </div>
                        </div>
                        <!-- <conference-info></conference-info> -->
                        <label class="request_for_demo_label_fixed default_actv"
                            @click="scrollTopOfDemoReqMethod">Register For
                            Demo</label>
                        <div class="more_info_add" v-if="authCheckLabelState">
                            <router-link class="more_info_add_btn" to="/login/">Login</router-link>
                            <router-link class="sign_up_btn ml-4" to="/signup/">Sign<span
                                    style="margin-left:3px;">Up</span>
                            </router-link>
                        </div>
                        <!-- login form code here -->
                        <main-login-form-popup v-if="mainLoginFormPopupState"></main-login-form-popup>
                        <!-- login form code here -->
                    </div>
                </section>
                <section class="request_for_demo_section_main">
                    <request-for-demo-popup></request-for-demo-popup>
                </section>
                <section class="section tukivita_section">
                    <tukivita-info-section></tukivita-info-section>
                </section>
                <section class="project_collaboration_section">
                    <project-collaboration-list></project-collaboration-list>
                </section>
                <section class="vista_screen_linkage">
                    <vista-linkage-screen></vista-linkage-screen>
                </section>
                <section class="vista_screen_linkage">
                    <our-past-event-screen></our-past-event-screen>
                </section>
            </div>
            <!-- <conference-info v-if="!isMobile"></conference-info> -->
        </section>
        <covid-popup v-if="!isMobile"></covid-popup>
        <lbil-linkage-info v-if="lbilLinkagePopupState"></lbil-linkage-info>
        <blocked-cookies-popup v-if="blockedCookiesPopupState"></blocked-cookies-popup>
    </main>
</template>

<script>
/*eslint-disable */

import 'fullpage-vue/src/fullpage.css'

import Register from '@/view/authentication/register/';
import Vue from 'vue';
import VueFullpage from 'fullpage-vue'
import blockedCookiesPopup from '@/components/common/blocked-cookies-in-safari-popup';
import { bus } from '@/main';
import covidPopup from '@/components/public/common/covid-19-popup';
import { getSafeLocalStorageItem } from '@/utils/localStorageHelper';
import lbilLinkagePopup from '@/components/public/lbil-linkage-blurb-popup';
import mainLoginFormPopup from '@/components/authentication/main-login-form-popup/';
import ourPastEventScreen from '@/components/public/our-past-event-screen/';
import pahsBannerInfo from '@/components/public/pahs-banner-info/';
import projectCollaborationList from '@/components/public/project-collaboration-list/';
import tukivitaInfoSection from '@/components/public/tukivita/list.vue';
import random_img from '@/assets/images/lange_crub.jpg';
import random_img1 from '@/assets/images/random_img/lange_crub_1.jpg';
import random_img2 from '@/assets/images/random_img/lange_crub_2.jpg';
import random_img3 from '@/assets/images/random_img/lange_crub_3.jpg';
import random_img4 from '@/assets/images/random_img/lange_crub_4.jpg';
import random_img5 from '@/assets/images/random_img/lange_crub_5.jpg';
import requestForDemoPopup from '@/components/public/request-for-demo-popup/';
import resendOtpPopup from '@/components/authentication/resend-otp-popup/';
import vistaLinkageScreen from '@/components/public/vista-linkage-screen/';

const $ = window.jQuery = require('jquery');
// Multi Color Bg Img Of Section
var randomImgLoaded;
var randomImgSlide;
Vue.use(VueFullpage);
export default {
    name: 'home-landing-main-page',
    components: {
        'covid-popup': covidPopup,
        'sign-up': Register,
        'lbil-linkage-info': lbilLinkagePopup,
        'resend-otp': resendOtpPopup,
        'request-for-demo-popup': requestForDemoPopup,
        'vista-linkage-screen': vistaLinkageScreen,
        'main-login-form-popup': mainLoginFormPopup,
        'our-past-event-screen': ourPastEventScreen,
        'pahs-banner-info': pahsBannerInfo,
        'project-collaboration-list': projectCollaborationList,
        'blocked-cookies-popup': blockedCookiesPopup,
        'tukivita-info-section':tukivitaInfoSection
    },
    props: [],
    data() {
        return {
            actvSidebar: false,
            preloader: true,
            randomImg: '',
            animationImg: '',
            first_slide: true,
            second_slide: false,
            getDetailsOfLoginUser: '',
            mblLogined: false,
            signUpFormEnabled: false,
            accept_terms: '',
            accordian1: true,
            accordian2: false,
            firstTimeVisit: (getSafeLocalStorageItem())
                ? sessionStorage.getItem('firstTimeVisit') : null,
            slideStatus: false,
            opts: {
                start: 0,
                dir: 'v',
                duration: 700,
                loop: false,
                overflow: 'auto',
                movingFlag: true,
                beforeChange(currentSlideEl, currenIndex, nextIndex) {
                    if (nextIndex == '1') {
                        $(".request_for_demo_label_fixed.default_actv").addClass('d-none');
                        $('.request_for_demo_label_fixed.slide_actv').removeClass('d-none');
                    } else {
                        $(".request_for_demo_label_fixed.default_actv").removeClass('d-none');
                        $('.request_for_demo_label_fixed.slide_actv').addClass('d-none');
                    }
                    if (nextIndex == '2' || nextIndex == '3' || nextIndex == '4' || nextIndex == '5') {
                        $('.request_for_demo_label_fixed').addClass('d-none');
                        $('.home_right_side_tools').addClass('d-none');
                    } else {
                        setTimeout(() => {
                            $('.home_right_side_tools').removeClass('d-none');
                        }, 150);
                    }
                    if (nextIndex == '0') {
                        setTimeout(() => {
                            $('.pahs_collaboration_info').removeClass('d-none');
                        }, 150);
                    } else {
                        $('.pahs_collaboration_info').addClass('d-none');
                    }
                },
                afterChange(currentSlideEl, currenIndex) {
                    if (currenIndex == '5') {
                        $('.footer_wrp').removeClass('d-none');
                    } else {
                        $('.footer_wrp').addClass('d-none');
                    }
                },
            },
            actvSlide: false,
            lbilLinkagePopupState: false,
            mainLoginFormPopupState: false,
            authBtnShowState: true,
            authCheckLabelState: false,
            safariBlockedCookiesState: false,
            blockedCookiesPopupState: false
        }
    },
    mounted() {
        if (getSafeLocalStorageItem()) {
            if (localStorage.getItem('token') && localStorage.getItem('LoginedUserID')) {
                this.authCheckLabelState = false;
            } else {
                this.authCheckLabelState = true;
                if (this.firstTimeVisit === null) {
                    sessionStorage.setItem('firstTimeVisit', 'visited');
                }
            }
        } else {
            console.warn('localStorage is not available. Some features may not work as expected.');
            this.safariBlockedCookiesState = true;
        }
        setTimeout(() => {
            this.actvSlide = true;
        }, 800)
        this.animationImg = random_img;
        $(document).ready(function (argument) {
            setTimeout(function () {
                $(".more_info_add").addClass("login_showing");
            }, 100)
        });
        bus.$emit('showHeaderbtn', false);
        this.randomImg = random_img;
        this.randomImgSlide();
        this.randomImgLoaded();
        randomImgSlide = setInterval(() => {
            this.randomImgSlide();
        }, 20000);
        randomImgLoaded = setInterval(() => {
            this.randomImgLoaded();
        }, 21500);
        bus.$on('showSignUpForm', (data) => {
            this.signUpFormEnabled = data;
            this.opts.movingFlag = false;
        });
        bus.$on('lbilLinkagePopupStateBus', (data) => {
            this.lbilLinkagePopupState = data;
        });
        bus.$on('mainLoginFormPopupStateBus', (data) => {
            this.mainLoginFormPopupState = data;
            this.opts.movingFlag = false;
            this.authBtnShowState = true;
        });
        bus.$on('moveToFirstInSliderBus', (data) => {
            if (data) {
                if (this.isMobile) {
                    this.scrollBackTopOfDemoReqMethod();
                } else {
                    this.movePrev();
                }
            }
        });
        bus.$on('movingFlagStateBus', (data) => {
            this.opts.movingFlag = data;
        });
        bus.$on('movingSlideStateBus', (index) => {
            this.moveToSection(index);
        });
        bus.$on('blockedCookiesPopupStateBus', (data) => {
            this.blockedCookiesPopupState = data;
        });
    },
    methods: {
        hideMenusPopup() {
            this.actvSidebar = false;
        },
        scrollTopOfDemoReqMethod() {
            let scrTop = $('.login_form_section')[0].scrollHeight
            $('html, body').animate({ scrollTop: scrTop - 40 }, 500);
        },
        scrollBackTopOfDemoReqMethod() {
            $('html, body').animate({ scrollTop: 0 }, 500);
        },
        moveToSection(sectionIndex) {
            this.$refs.example.$fullpage.moveTo(sectionIndex/*move to index*/, true /*animatied*/, false /*force move?*/)
        },
        moveNext() {
            this.$refs.example.$fullpage.moveNext(); //Move to the next page
        },
        movePrev() {
            this.$refs.example.$fullpage.movePrev(); //Move to the next page
        },
        loginFormShowMethod() {
            $(window).scrollTop(0);
            this.opts.movingFlag = true;
            this.mainLoginFormPopupState = true;
            this.authBtnShowState = false;
        },
        signUpFormShow() {
            setTimeout(() => {
                bus.$emit('showSignUpForm', true);
                this.opts.movingFlag = true;
                $('body').addClass('registration_form');
            }, 1)
        },
        lbilLinkagePopupOpenMethod() {
            this.lbilLinkagePopupState = true
        },
        onResize() {
            this.isMobile = window.innerWidth < 1023;
        },
        playSound(sound) {
            if (sound) {
                var audio = new Audio(sound);
                audio.play();
            }
        },
        randomImgSlide() {
            setTimeout(() => {
                $(".oncology_well_new").addClass("active");
                $(".oncology_wel_popup").removeClass("active");
                setTimeout(() => {
                    $(".oncology_well_new").css('z-index', '10');
                    $(".oncology_wel_popup").css('z-index', '11');
                    $(".oncology_wel_line_crub").addClass("animation_play");
                }, 1505)
            }, 10000)
            setTimeout(() => {
                $(".oncology_well_new").removeClass("active");
                $(".oncology_wel_popup").addClass("active");
                setTimeout(() => {
                    $(".oncology_wel_popup").css('z-index', '10');
                    $(".oncology_well_new").css('z-index', '11');
                    $(".oncology_wel_line_crub").removeClass("animation_play");
                }, 1500)
            }, 20000)
        },
        randomImgLoaded() {
            setTimeout(() => {
                this.randomImg = random_img1;
            }, 3500)
            setTimeout(() => {
                this.randomImg = random_img;
            }, 5500)
            setTimeout(() => {
                this.randomImg = random_img2;
            }, 7500)
            setTimeout(() => {
                this.randomImg = random_img;
            }, 9500)
            setTimeout(() => {
                this.randomImg = random_img3;
            }, 11500)
            setTimeout(() => {
                this.randomImg = random_img;
            }, 13500)
            setTimeout(() => {
                this.randomImg = random_img4;
            }, 15500)
            setTimeout(() => {
                this.randomImg = random_img;
            }, 17500)
            setTimeout(() => {
                this.randomImg = random_img5;
            }, 19500)
            setTimeout(() => {
                this.randomImg = random_img;
            }, 21500)
        },
    },
    beforeCreate: function () {
        document.body.classList.add('login_body');
        $('.footer_wrp').addClass('d-none');
    },
    beforeRouteLeave: function (to, from, next) {
        this.signUpFormEnabled = false;
        document.body.classList.remove('login_body');
        $(".sign_up_btn").removeClass("d-none");
        $('body').removeClass('registration_form');
        $('.footer_wrp').removeClass('d-none');
        clearInterval(randomImgSlide);
        clearInterval(randomImgLoaded);
        next();
    },
    created() {
        window.addEventListener('resize', this.onResize, {
            passive: true
        })
        this.onResize()
    },
    beforeDestroy() {
        if (typeof window !== 'undefined') {
            window.removeEventListener('resize', this.onResize, {
                passive: true
            })
        }
    },
}
</script>

<style lang="scss" scoped>
// @import url('../../../assets/fonts/acetone/style.css');
// @import url("../../../assets/fonts/AceSansDemo/styles.css");
@keyframes circle {
    from {
        -webkit-clip-path: circle(0%);
        clip-path: circle(0%);
    }

    to {
        -webkit-clip-path: circle(657px);
        clip-path: circle(657px);
    }
}

@-webkit-keyframes mask-play {
    from {
        -webkit-mask-position: 0% 0;
        mask-position: 0% 0;
    }

    to {
        -webkit-mask-position: 100% 0;
        mask-position: 100% 0;
    }
}

@keyframes mask-play {
    from {
        -webkit-mask-position: 0% 0;
        mask-position: 0% 0;
    }

    to {
        -webkit-mask-position: 100% 0;
        mask-position: 100% 0;
    }
}

@-webkit-keyframes ca3_fade_move_down {
    0% {
        -webkit-transform: translate(0, -15px);
        opacity: 0;
    }

    50% {
        opacity: 1;
    }

    100% {
        -webkit-transform: translate(0, 15px);
        opacity: 0;
    }
}

@-moz-keyframes ca3_fade_move_down {
    0% {
        -moz-transform: translate(0, -15px);
        opacity: 0;
    }

    50% {
        opacity: 1;
    }

    100% {
        -moz-transform: translate(0, 15px);
        opacity: 0;
    }
}

@keyframes ca3_fade_move_down {
    0% {
        transform: translate(0, -15px);
        opacity: 0;
    }

    50% {
        opacity: 1;
    }

    100% {
        transform: translate(0, 15px);
        opacity: 0;
    }
}

@-webkit-keyframes ca3_fade_move_top {
    0% {
        -webkit-transform: translate(0, 15px);
        opacity: 0;
    }

    50% {
        opacity: 1;
    }

    100% {
        -webkit-transform: translate(0, -15px);
        opacity: 0;
    }
}

@-moz-keyframes ca3_fade_move_top {
    0% {
        -moz-transform: translate(0, 15px);
        opacity: 0;
    }

    50% {
        opacity: 1;
    }

    100% {
        -moz-transform: translate(0, -15px);
        opacity: 0;
    }
}

@keyframes ca3_fade_move_top {
    0% {
        transform: translate(0, 15px);
        opacity: 0;
    }

    50% {
        opacity: 1;
    }

    100% {
        transform: translate(0, -15px);
        opacity: 0;
    }
}

@-webkit-keyframes glow {
    from {
        -webkit-filter: drop-shadow(0 0 2px #FF9900);
        filter: drop-shadow(0 0 2px #FF9900);
    }

    to {
        -webkit-filter: drop-shadow(0 0 6px #FF9900);
        filter: drop-shadow(0 0 6px #FF9900);
    }
}

.oncology_wel_popup {
    position: relative;
    text-align: center;
    overflow: hidden;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: #000000;
    -webkit-mask: url("../../../assets/slider/images/nature-sprite-2.png");
    mask: url("../../../assets/slider/images/nature-sprite-2.png");
    -webkit-mask-size: 7100% 100%;
    mask-size: 7100% 100%;
}

.oncology_wel_popup_inner {
    .oncology_wel_lange_img {
        display: block;
        margin: 0 auto;
        height: 100dvh;
        object-fit: cover;
        padding-top: 20px;

        .img-fluid {
            height: 87%;
        }
    }

    display: inline-block;
    position: relative;
    margin: 0 auto;
    vertical-align: middle;
}

.more_info_add_btn {
    font-family: 'ACETONE';
    background: rgba(0, 0, 0, 0.6);
    border: 2px solid #ffe400 !important;
    color: #ffe400 !important;
    text-transform: uppercase;
    font-size: 28px;
    padding: 5px 8px;
    line-height: 1;
    height: auto;
    min-width: 110px;
    display: inline-block;
    border-radius: 6px;
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
    outline: none !important;
    text-decoration: none !important;

    &:hover {
        background: #ffe400 !important;
        color: #000000 !important;
    }
}

.sign_up_btn {
    font-family: 'ACETONE';
    background: rgba(0, 0, 0, 0.6);
    border: 2px solid #ffd400 !important;
    color: #ffd400 !important;
    text-transform: uppercase;
    font-size: 28px;
    padding: 5px 8px;
    line-height: 1;
    height: auto;
    min-width: 110px;
    display: inline-block;
    border-radius: 6px;
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
    outline: none !important;
    text-decoration: none !important;

    &:hover {
        background: #ffe400 !important;
        color: #000000 !important;
    }
}

.more_info_add {
    position: absolute;
    bottom: -80px;
    left: 0;
    right: 0;
    transition: all ease 0.8s;
    -webkit-transition: all ease 0.8s;
}

.more_info_add.login_showing {
    bottom: 20px;

    @media only screen and (max-width:1023px) {
        position: static !important;
        margin-top: 25px;
    }
}

.popup_actv {
    .lymphomap_inner_wrp {
        opacity: 0;
    }

    .more_info_add {
        display: none;
    }

    .lymphomap_ab_btn {
        display: none;
    }

    .lymphomap_computer_btn {
        display: none;
    }

    .cancer_classification_btn {
        display: none;
    }

    .public_vista_btn {
        display: none;
    }
}

.oncology_wel_line_crub {
    .oncology_wel_left_line_crub {
        position: absolute;
        top: -2px;
        left: -7%;
        right: 0;
        width: 110%;
        bottom: 0;
    }

    .img-fluid {
        height: 100%;
        opacity: 0;
    }
}

.oncology_wel_line_crub.animation_play {
    .img-fluid {
        animation: 2.8s alternate circle;
        opacity: 1;
    }
}

.oncology_well_new_img {
    background-image: url("../../../assets/images/lymphomap-landing-blank.jpg");
    height: 100dvh;
    width: 100%;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: top center;
    text-align: center;

    .img-fluid {
        height: 100%;
    }
}

.lymphomap_auth_main {
    position: relative;
    overflow: hidden;
    min-height: 100dvh;

    .oncology_well_form {
        max-width: 530px;
        min-height: 100dvh;
        position: relative;
        top: 0;
        left: 0;
        right: 0;
        margin: 0 auto;
        text-align: center;
        z-index: 999;

        @media only screen and (max-width:767px) {
            z-index: 99;
        }
    }

    .fullpage-container {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;

        .section {
            position: relative;
        }
    }
}

.oncology_well_new.active {
    -webkit-animation: mask-play 1.5s steps(70) forwards;
    animation: mask-play 1.5s steps(70) forwards;
}

.oncology_wel_popup.active {
    -webkit-animation: mask-play 1.5s steps(70) forwards;
    animation: mask-play 1.5s steps(70) forwards;
}

.oncology_well_new {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    -webkit-mask: url("../../../assets/slider/images/nature-sprite-2.png");
    mask: url("../../../assets/slider/images/nature-sprite-2.png");
    -webkit-mask-size: 7100% 100%;
    mask-size: 7100% 100%;
}

.oncology_well_slider {
    position: fixed;
    height: 100dvh;
    width: 100%;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
}

.welcome_popup_inner {
    .section_heading {
        a {
            font-family: "Helvetica Neue", sans-serif;
        }
    }
}

.lymphomap_ab_btn {
    position: fixed;
    // top:20%;
    top: 15%;
    transform: translateY(-50%);
    -webkit-transform: translateY(-50%);
    -moz-transform: translateY(-50%);
    right: 20px;
    z-index: 100;
    opacity: 1;

    .btn {
        font-size: 34px;
        color: #ffffff;
        box-shadow: none;
        outline: none;
        padding: 0;
        background: rgba(255, 255, 255, 0.1);
        border-radius: 3px;
        text-align: center;
        min-width: 100px;
        height: 50px;
        line-height: 50px;
        border: none;

        &:hover {
            background-color: #87cefa;
            color: #000;

            path {
                fill: #000000;
            }

            polygon {
                fill: #000000;
            }
        }
    }
}

.lymphomap_about {
    .section_heading {
        font-size: 30px;
        text-align: justify;
        color: #d6d6d6;

        @media only screen and (max-width:767px) {
            font-size: 22px;
        }
    }
}

.lymphomap_computer_btn {
    position: fixed;
    top: 35%;
    transform: translateY(-50%);
    -webkit-transform: translateY(-50%);
    -moz-transform: translateY(-50%);
    right: 20px;
    z-index: 100;
    opacity: 1;

    .btn {
        font-size: 25px;
        color: #ffffff;
        -webkit-box-shadow: none;
        box-shadow: none;
        outline: none;
        padding: 0;
        background: rgba(255, 255, 255, 0.1);
        border-radius: 3px;
        text-align: center;
        min-width: 100px;
        height: 50px;
        line-height: 50px;
        border: none;

        .fa {
            text-shadow: 0 0 2px #fff, 0 0 5px #ff00de;
        }

        .img-fluid {
            width: 38px;
        }

        &:hover {
            background-color: #87cefa;
            color: #000000;

            .hover_img {
                display: inline-block;
            }

            .normal_img {
                display: none;
            }

            path {
                fill: #000000;
            }

            polygon {
                fill: #000000;
            }
        }
    }
}

.cancer_classification_btn {
    position: fixed;
    top: 25%;
    transform: translateY(-50%);
    -webkit-transform: translateY(-50%);
    -moz-transform: translateY(-50%);
    right: 20px;
    z-index: 100;
    opacity: 1;

    .landing_custom_tooltop_wrp {
        .landing_custom_tooltop {
            width: 230px;
        }
    }

    .btn {
        font-size: 25px;
        color: #ffffff;
        -webkit-box-shadow: none;
        box-shadow: none;
        outline: none;
        padding: 0;
        background: rgba(255, 255, 255, 0.1);
        border-radius: 3px;
        text-align: center;
        min-width: 100px;
        height: 50px;
        line-height: 50px;
        border: none;

        .fa {
            text-shadow: 0 0 2px #fff, 0 0 5px #ff00de;
        }

        &:hover {
            background-color: #87cefa;
            color: #000000;

            path {
                fill: #000000;
            }

            polygon {
                fill: #000000;
            }

            ellipse {
                fill: #000000;
            }

            circle {
                fill: #000000;
            }
        }
    }
}

.public_vista_btn {
    position: fixed;
    top: 65%;
    transform: translateY(-50%);
    -webkit-transform: translateY(-50%);
    -moz-transform: translateY(-50%);
    right: 20px;
    z-index: 100;
    opacity: 1;

    &.lbil_linkage_icon {
        top: 45%;

        @media only screen and (max-width:767px) {
            top: 55%;
        }
    }

    &.app_for_icon {
        top: 75%;
    }

    &.package_subscription_icon {
        top: 55%;

        @media only screen and (max-width:767px) {
            top: 65%;
        }

        .landing_custom_tooltop_wrp {
            .landing_custom_tooltop {
                width: 160px;
            }
        }
    }

    .btn {
        font-size: 25px;
        color: #ffffff;
        -webkit-box-shadow: none;
        box-shadow: none;
        outline: none;
        padding: 0;
        background: rgba(255, 255, 255, 0.1);
        border-radius: 3px;
        text-align: center;
        min-width: 100px;
        height: 50px;
        line-height: 50px;
        border: none;

        .fa {
            color: #ffc107;
            font-size: 50px;
            transform: scale(1);
            -webkit-transform: scale(1);
            -moz-transform: scale(1);
            -webkit-transition: -webkit-transform ease 0.5s;
            transition: -webkit-transform ease 0.5s;
            transition: transform ease 0.5s;
            transition: transform ease 0.5s, -webkit-transform ease 0.5s;
            -webkit-transition: transform ease 0.5s;
            -moz-transition: transform ease 0.5s;
            -webkit-animation: glow 1.5s ease-in-out infinite alternate;
            animation: glow 1.5s ease-in-out infinite alternate;
            transform-origin: center center;
        }

        .img-fluid {
            transform: scale(1);
            -webkit-transform: scale(1);
            -moz-transform: scale(1);
            -webkit-transition: -webkit-transform ease 0.5s;
            transition: -webkit-transform ease 0.5s;
            transition: transform ease 0.5s;
            transition: transform ease 0.5s, -webkit-transform ease 0.5s;
            -webkit-transition: transform ease 0.5s;
            -moz-transition: transform ease 0.5s;
            -webkit-animation: glow 1.5s ease-in-out infinite alternate;
            animation: glow 1.5s ease-in-out infinite alternate;
            transform-origin: center center;

            &.hover_view_icon {
                display: none !important;
            }
        }

        &:hover {
            background-color: #87cefa;
            color: #000000;

            .fa {
                color: #000000;
                transform: scale(1.1);
                -webkit-transform: scale(1.1);
                -moz-transform: scale(1.1);
                -webkit-animation-play-state: paused;
                animation-play-state: paused;
            }

            .img-fluid {
                &.normal_view_icon {
                    filter: invert(1) saturate(0%) hue-rotate(0deg) brightness(0%) contrast(500%) drop-shadow(0 0 6px #FF9900) !important;
                    -webkit-filter: invert(1) saturate(0%) hue-rotate(0deg) brightness(0%) contrast(500%) drop-shadow(0 0 6px #FF9900) !important;
                    transform: scale(1.1);
                    -webkit-transform: scale(1.1);
                    -moz-transform: scale(1.1);
                    -webkit-animation-play-state: paused;
                    animation-play-state: paused;
                }
            }
        }
    }

    .landing_custom_tooltop_wrp {
        .landing_custom_tooltop {
            top: auto;
            bottom: 0;
        }
    }

    &.our_event_link {
        top: 85%;

        .btn .fa {
            font-size: 36px;
            margin-top: 6px;
        }
    }
}

.lymphomap_computer_data {
    .section_heading {
        span {
            font-size: 32px;

            a {
                font-size: 22px;
            }
        }

        font-size: 22px;
        margin-bottom: 20px;
        text-align: justify;

        a {
            color: #3686ea;
        }

        &:last-child {
            margin-bottom: 0px;
        }
    }

    font-family: -apple-system,
    BlinkMacSystemFont,
    Segoe UI,
    Helvetica Neue,
    Arial,
    sans-serif,
    Apple Color Emoji,
    Segoe UI Emoji,
    Segoe UI Symbol,
    Noto Color Emoji;

    .welcome_popup_inner {
        height: calc(100dvh - 80px);
        overflow-y: auto;

        &::-webkit-scrollbar {
            width: 0px;
            background: transparent;
            border-radius: 2px;
        }

        &::-webkit-scrollbar-thumb {
            background-color: #000;
        }
    }
}

.computer_popup_heading {
    color: #d29e00;
    font-size: 40px;
    margin-bottom: 30px;
    font-family: 'origin_tech_demoregular';

    @media only screen and (max-width:767px) {
        font-size: 32px;
        margin-bottom: 15px;
    }
}

.learning_algo_instruction_txt {
    font-family: 'AlienAndroid';
}

.computer_popup_list {
    li {
        margin-bottom: 15px;
        color: #d6d6d6;
        font-size: 20px;
        position: relative;
        padding-left: 35px;
        font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Helvetica Neue, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color emoji;
        text-align: justify;

        &:last-child {
            margin-bottom: 0;
        }

        .fa {
            position: absolute;
            top: 5px;
            left: 0;
            color: #d29e00;
        }
    }

    margin: 0;
}

.next_step_arrow {
    p {
        font-size: 20px;
        color: #ffffff;
    }

    p.yellow_clr {
        color: #ffc107;
    }

    margin-top: 35px;
    position: relative;
}

.three_down_arrow {
    cursor: pointer;
    height: 30px;
    width: 30px;
    position: absolute;
    bottom: -55px;
    -webkit-animation: ca3_fade_move_down 3s ease-in-out infinite;
    -moz-animation: ca3_fade_move_down 3s ease-in-out infinite;
    animation: ca3_fade_move_down 3s ease-in-out infinite;

    &:hover {
        -webkit-animation-play-state: paused;
        animation-play-state: paused;
        -moz-animation-play-state: paused;
    }
}

.ab_down_arrow {
    cursor: pointer;
    height: 30px;
    width: 30px;
    margin: 15px auto 0;
    position: static;
    display: block;
    -webkit-animation: ca3_fade_move_down 3s ease-in-out infinite;
    -moz-animation: ca3_fade_move_down 3s ease-in-out infinite;
    animation: ca3_fade_move_down 3s ease-in-out infinite;

    &:hover {
        -webkit-animation-play-state: paused;
        animation-play-state: paused;
        -moz-animation-play-state: paused;
    }
}

.lymphomap_computer_data_inner {
    height: calc(100dvh - 80px);
    display: table;
    width: 100%;
}

.lymphomap_computer_data_inner_second {
    height: calc(100dvh - 80px);
    display: table;
    width: 100%;
}

.lymphomap_computer_center_data {
    display: table-cell;
    vertical-align: middle;
}

.ab_main_popup.main_scroll_disabled {
    position: absolute;
}

.prev_step_arrow {
    position: relative;
    height: 50px;
}

.three_top_arrow {
    cursor: pointer;
    height: 30px;
    width: 30px;
    position: absolute;
    bottom: 20px;
    -webkit-animation: ca3_fade_move_top 3s ease-in-out infinite;
    -moz-animation: ca3_fade_move_top 3s ease-in-out infinite;
    animation: ca3_fade_move_top 3s ease-in-out infinite;

    &:hover {
        -webkit-animation-play-state: paused;
        animation-play-state: paused;
        -moz-animation-play-state: paused;
    }
}

.ab_top_arrow {
    cursor: pointer;
    display: block;
    height: 30px;
    width: 30px;
    margin: 0 auto 10px;
    -webkit-animation: ca3_fade_move_top 3s ease-in-out infinite;
    -moz-animation: ca3_fade_move_top 3s ease-in-out infinite;
    animation: ca3_fade_move_top 3s ease-in-out infinite;

    &:hover {
        -webkit-animation-play-state: paused;
        animation-play-state: paused;
        -moz-animation-play-state: paused;
    }
}

.login_optional_tabs {
    margin: 0 -3px 15px;
    padding: 0;
    list-style-type: none;
    display: flex;

    li {
        flex-grow: 1;
        text-align: center;
        padding: 0 3px;

        .btn-default {
            background: rgba(255, 255, 255, 0.1);
            width: 100%;
            color: #fff;
            padding: 6px 0;
            font-size: 15px;
        }

        &:hover {
            .btn-default {
                background: #ffffff;
                color: #000000;
            }
        }
    }

    li.active {
        .btn-default {
            background: #ffffff;
            color: #000000;
        }
    }
}

.show_login_user_label {
    height: 40px;
    width: 100%;
    border: none;
    background: rgba(40, 40, 40, 0.8);
    padding: 8px 15px;
    outline: none;
    font-size: 18px;
    font-weight: 300;
    color: #fff;
    border-radius: 4px;
    margin-bottom: 0px;
    cursor: pointer;
    position: relative;
}

.show_login_user_label_txt {
    font-size: 16px;
    text-align: right;
    padding-right: 15px;
}

.show_login_user_label_wrp {
    margin-bottom: 20px;
    position: relative;
    padding-right: 45px;
}

.custom_radio_button {
    position: absolute;
    right: 0;
    top: 5px;
    margin: 0;
    display: block;

    input[type='radio'] {
        visibility: hidden;
        opacity: 0;
    }

    span {
        display: inline-block;
        width: 30px;
        height: 30px;
        background: #3498db;
        border-radius: 50%;
        vertical-align: middle;
        border: 2px solid #fff;
        position: relative;
        cursor: pointer;
    }

    input[type="radio"] {
        &:checked {
            + {
                span {
                    &:before {
                        content: "";
                        background-image: url("../../../assets/images/check-icn.svg");
                        width: 15px;
                        height: 15px;
                        position: absolute;
                        background-repeat: no-repeat;
                        background-size: 100% 100%;
                        top: 50%;
                        transform: translateY(-50%);
                        background-position: center center;
                        left: 5px;
                        -webkit-transform: translateY(-50%);
                        -moz-transform: translateY(-50%);
                    }
                }
            }
        }
    }
}

.ab_main_popup {
    .computer_popup_list {
        li {
            span {
                color: #87cefa;
                font-size: 22px;
                font-family: 'BeonMedium', sans-serif;
            }

            margin-bottom: 10px;
            font-size: 22px;

            &:last-child {
                margin-bottom: 0px;
            }
        }
    }
}

.landing_custom_tooltop_wrp {
    position: relative;

    .landing_custom_tooltop {
        right: calc(100% + 8px);
        position: absolute;
        background: #ffdee3;
        width: 112px;
        padding: 3px 4px;
        cursor: default;
        z-index: 999;
        border-radius: 0;
        font-weight: 600;
        line-height: 1.4;
        font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Helvetica Neue, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color emoji;
        font-size: 16px;
        color: #000;
        top: 0;
        border-radius: 2px;
        display: none;

        &:before {
            border: solid;
            border-color: #ffdee3 transparent;
            border-width: 12px 12px 0px 0px;
            top: 8px;
            content: "";
            display: block;
            right: -5px;
            position: absolute;
            z-index: 1000;
            -webkit-transform: rotate(135deg);
            transform: rotate(135deg);
        }
    }

    &:hover {
        .landing_custom_tooltop {
            display: block;
        }

        svg {
            transform: scale(1.1);
            -webkit-transform: scale(1.1);
            -moz-transform: scale(1.1);
            -webkit-animation-play-state: paused;
            -moz-animation-play-state: paused;
            animation-play-state: paused;
        }
    }

    svg {
        transform: scale(1);
        -webkit-transform: scale(1);
        -moz-transform: scale(1);
        transition: transform ease 0.5s;
        -webkit-transition: transform ease 0.5s;
        -moz-transition: transform ease 0.5s;
        -webkit-animation: glow 1.5s ease-in-out infinite alternate;
        -moz-animation: glow 1.5s ease-in-out infinite alternate;
        animation: glow 1.5s ease-in-out infinite alternate;
    }
}

.landing_custom_tooltop_wrp.about_us_custom_tooltop_wrp {
    .landing_custom_tooltop {
        top: 0;
        bottom: auto;
        width: 80px;
    }
}

.welcome_audio_player {
    position: absolute;
    top: 0;
    z-index: 10000;
}

.about_us_list_heading {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    line-height: 1.3;
    text-align: justify;
    margin: 0px;
    color: #ffc107;
    font-size: 24px;
    font-weight: 600;
    cursor: pointer;
    position: relative;
    padding-right: 40px;
}

.about_us_list_accordion {
    .computer_popup_list {
        display: none;
        padding-top: 15px;
    }

    padding: 12px 0;
}

.ab_accordion_arrow {
    position: absolute;
    right: 0;
    top: 5px;
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
    -webkit-transition: all ease 0.1s;
    transition: all ease 0.1s;
}

.about_us_list_accordion.about_accordion_active {
    .ab_accordion_arrow {
        transform: rotate(90deg);
        -webkit-transform: rotate(90deg);
    }
}

.ab_us_second_section_list {
    h4 {
        font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
        line-height: 1.3;
        text-align: justify;
        margin: 0px;
        color: #d6d6d6;
        font-size: 26px;
        font-weight: 600;
        position: relative;
        padding: 10px 0 10px 54px;

        .img-fluid {
            position: absolute;
            left: 0;
            top: 10px;
            width: 40px;
        }
    }

    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-flex: 1;
    -ms-flex-positive: 1;
    flex-grow: 1;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
}

.ab_us_accordion_content {
    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Helvetica Neue, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;
    padding-bottom: 25px;
    order: 2;
    -webkit-order: 2;
    -moz-order: 2;
    flex: 0 0 100%;
    width: 100%;

    .ab_us_accordion_panel {
        padding: 0 18px;
        display: none;
        overflow: hidden;
    }

    .ab_us_accordion_title_wrp {
        position: relative;
        padding-left: 45px;
        cursor: pointer;

        .about_us_acc_icon {
            position: absolute;
            left: 0;
            top: 4px;
        }

        .fa {
            position: absolute;
            right: 0;
            top: 10px;
            font-size: 20px;
            color: #87cefa;
        }

        .ab_us_accordion_title {
            font-size: 26px;
            font-weight: 500;
            color: #87cefa;
            line-height: 1.1;
            margin-bottom: 0px;

            @media only screen and (max-width:767px) {
                font-size: 22px;
            }
        }
    }

    .ab_us_accordion_panel_list_wrp {
        padding-left: 35px;
        padding-top: 12px;
        margin-bottom: 0px;

        li {
            font-size: 18px;
            color: #d6d6d6;
            margin-bottom: 5px;
            position: relative;
            padding-left: 18px;

            &:last-child {
                margin-bottom: 0px;
            }

            .fa {
                position: absolute;
                top: 6px;
                left: 0;
                color: #ffc107;
                font-size: 13px;
            }
        }
    }
}

.ab_us_accordion_content.active {
    order: 1;
    -webkit-order: 1;
    -moz-order: 1;
}

.about_second_section {
    .ab_top_arrow {
        margin-bottom: 40px;
    }
}

.ab_down_for_lbil_arrow {
    cursor: pointer;
    height: 30px;
    width: 30px;
    margin: 15px auto 0;
    position: static;
    display: block;
    -webkit-animation: ca3_fade_move_down 3s ease-in-out infinite;
    -moz-animation: ca3_fade_move_down 3s ease-in-out infinite;
    animation: ca3_fade_move_down 3s ease-in-out infinite;

    &:hover {
        -webkit-animation-play-state: paused;
        animation-play-state: paused;
        -moz-animation-play-state: paused;
    }
}

.ab_top_for_lbil_arrow {
    cursor: pointer;
    display: block;
    height: 30px;
    width: 30px;
    margin: 0 auto 10px;
    -webkit-animation: ca3_fade_move_top 3s ease-in-out infinite;
    -moz-animation: ca3_fade_move_top 3s ease-in-out infinite;
    animation: ca3_fade_move_top 3s ease-in-out infinite;

    &:hover {
        -webkit-animation-play-state: paused;
        animation-play-state: paused;
        -moz-animation-play-state: paused;
    }
}

.lbil_ab_heading {
    color: #d29e00;
    font-size: 46px;
    margin-bottom: 25px;
    font-family: 'BeonMedium', sans-serif;
}

.about_lbil_third_section {
    .ab_us_accordion_content {
        .ab_us_accordion_title_wrp {
            .about_us_acc_icon {
                top: -2px;
            }
        }
    }
}

@media only screen and (max-width:767px) {
    .lymphomap_ab_btn {
        top: 18%;
    }

    .cancer_classification_btn {
        top: 26%;
    }

    .lymphomap_computer_btn {
        top: 34%;
    }

    .public_vista_btn {
        top: 42%;
    }

    .public_vista_btn.lbil_linkage_icon {
        top: 50%;
    }

    .public_vista_btn.package_subscription_icon {
        top: 58%;
    }

    .public_vista_btn.app_for_icon {
        top: 66%;
    }

    .oncology_well_new_img {
        display: flex;
        align-items: center;

        .img-fluid {
            height: 60%;
            object-fit: cover;
            object-position: center center;
        }
    }

    .oncology_wel_popup_inner .oncology_wel_lange_img {
        display: flex;
        align-items: center;

        .img-fluid {
            height: auto;
        }
    }

    .landing_custom_tooltop_wrp svg {
        width: 40px;
    }

    .lymphomap_ab_btn .landing_custom_tooltop_wrp svg {
        width: 35px;
    }

    .app_for_icon.public_vista_btn .btn .img-fluid {
        width: 55px;
    }
}

.request_for_demo_label_fixed {
    background: #e4002b;
    font-family: 'MyriadProRegular', 'Lato', sans-serif;
    position: absolute;
    top: calc(50% - 90px);
    color: #fff;
    line-height: 38px;
    width: 180px;
    text-align: center;
    font-size: 18px;
    border-radius: 0px 70px 70px 0px;
    z-index: 999;
    box-shadow: 0px 0px 12px rgba(255, 255, 255, 0.2);
    cursor: pointer;
    left: -200px;
    transition: left ease 0.7s;
    -webkit-transition: left ease 0.7s;
    -moz-transition: left ease 0.7s;
    letter-spacing: 1px;

    &.active {
        left: 0px;
    }

    &:hover {
        background: #ffe400;
        color: #22292f
    }

    &.slide_actv {
        background: #279b37;
        color: #ffffff;
        left: 0;

        &:hover {
            background: #ffe400;
            color: #22292f
        }
    }

    @media only screen and (max-width:1360px) and (min-width:768px) {
        font-size: 16px;
    }

    @media only screen and (max-width:1290px) and (min-width:1260px) and (max-height:699px) {
        line-height: 32px;
    }
}

.full_section_in_mbl {
    section {
        min-height: inherit;
        position: relative;
    }

    .fa-times-circle-o {
        display: none;
    }

    .request_for_demo_section_main,
    .vista_screen_linkage {
        z-index: 100;
    }

    .landing_page_linkage_option {
        padding: 75px 15px 20px;
        clear: both;
        width: 100%;
        display: table;
        background: rgba(2, 2, 1, 0.3);

        .landing_page_linkage_box {
            background: rgba(38, 38, 39, 0.7);
            width: 49%;
            float: left;
            min-height: 85px;
            margin: 0.5%;
            font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Helvetica Neue, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color emoji;
            box-shadow: 0px 0px 4px rgba(253, 255, 206, 0.3);

            a {
                text-decoration: none !important;
            }

            span {
                display: block;

                .fa {
                    color: #ffc107;
                    font-size: 48px;
                }

                &.linkage_box_title {
                    color: #ffc107;
                    font-size: 18px;

                    @media only screen and (max-width:479px) {
                        font-size: 16px;
                    }
                }

                &.linkage_box_icon {
                    min-height: 55px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    padding-top: 5px;
                }
            }

            .landing_page_linkage_option {
                padding-top: 120px;
            }

            .landing_page_linkage_item {
                padding: 10px;
            }

            &.last_item_of_box {
                width: 99%;
            }

            &:hover {
                background: #ffc107;

                .linkage_box_title {
                    color: #000000 !important;
                }

                .fa {
                    color: #000000 !important;
                }

                img {
                    filter: invert(1) saturate(0%) hue-rotate(0deg) brightness(0%) contrast(500%) drop-shadow(0 0 6px #FF9900);
                    -webkit-filter: invert(1) saturate(0%) hue-rotate(0deg) brightness(0%) contrast(500%) drop-shadow(0 0 6px #FF9900);
                }

                path {
                    fill: #000000;
                }

                ellipse {
                    fill: #000000;
                }
            }
        }

        @media only screen and (max-width:479px) {
            padding: 75px 10px 20px;
        }
    }
}

.fullpage-wp.anim {
    -webkit-transition: all 700ms ease-out 0s;
    -webkit-transition: all 700ms ease-out 0s;
    transition: all 700ms ease-out 0s;
}

@media only screen and (max-width: 1290px) and (min-width: 1260px) and (max-height: 699px) {
    .request_for_demo_section_main {
        padding-top: 20px;
    }
}

.landing_right_sidebar {
    position: fixed;
    right: 0;
    top: 0;
    z-index: 900;
    height: 0px;

    .r_sidebar_box {
        // border: 1px solid rgba(40, 40, 40, 0.6);
        border: 1px solid rgba(93, 93, 93, 0.4);
        width: 280px;
        // background-color: rgba(31, 31, 31, 0.8);
        border-radius: 4px;
        line-height: 1;
        // height: 100%;
        display: flex;
        align-items: center;
        transform: translateX(100%);
        -webkit-transform: translateX(100%);
        -moz-transform: translateX(100%);
        transition: transform 0.4s ease;
        -webkit-transition: transform 0.4s ease;
        -moz-transition: transform 0.4s ease;
        background: linear-gradient(-30deg, rgba(37, 44, 84, 0.8) 0%, rgba(0, 0, 0, 0.8) 50%, rgba(38, 38, 38, 0.8) 50%, rgba(44, 44, 84, 0.8) 100%);

        &.active {
            transform: translateX(0%);
            -webkit-transform: translateX(0%);
            -moz-transform: translateX(0%);
        }

        .r_sidebar_menus {
            width: 100%;
        }

        .r_sidebar_item {
            // border-bottom: 1px solid rgba(40, 40, 40, 0.8);
            border-bottom: 1px solid rgba(93, 93, 93, 0.5);

            &:last-child {
                border-bottom: 0px;

                a {
                    border-radius: 0px 0px 4px 4px;
                }
            }

            &:first-child {
                a {
                    border-radius: 4px 4px 0px 0px;
                }
            }

            a {
                display: flex;
                align-items: center;
                gap: 15px;
                padding: 8px 10px;

                .r_sidebar_text {
                    font-family: 'MyriadProRegular', 'Lato', sans-serif;
                    font-size: 16px;
                    letter-spacing: 1px;
                    color: #efefef;
                    line-height: 1.3;
                    font-family: 'AceSansDemo', 'MyriadProRegular', 'Lato', sans-serif;
                }

                .r_sidebar_icon {
                    flex: 0 0 40px;
                    text-align: center;

                    .fa {
                        color: #ffc107;
                    }
                }

                &:hover {
                    background: #ffffff;

                    .r_sidebar_text {
                        color: #000000;
                        font-weight: bold;
                    }

                    .fa {
                        color: #000000;
                    }

                    * {
                        fill: #000000;
                    }

                    img {
                        filter: brightness(0) contrast(100%);
                    }
                }
            }
        }
    }

    .menuburger_f_sidebar {
        padding: 10px 15px 20px;
        text-align: right;

        .btn {
            padding: 0px 10px;
            color: #ffd400;
            font-size: 24px;
            background-color: rgba(31, 31, 31, 0.5);
            border-radius: 4px;
            line-height: 1;
            box-shadow: none !important;
            border: 1px solid rgba(174, 182, 184, 0.1);
            position: relative;
            overflow: hidden;
            height: 38px;
            line-height: 38px;

            &::before {
                content: "";
                position: absolute;
                top: 0;
                width: 100%;
                height: 100%;
                background: linear-gradient(120deg,
                        transparent,
                        rgba(255, 255, 255, 0.2),
                        transparent);
                left: -100%;
                transition: all 0.65s ease-in-out;
            }

            &:hover {
                box-shadow: 1px 1px 25px 10px rgba(255, 255, 255, 0.5) !important;

                &::before {
                    left: 100%;
                }
            }

            // &:hover{background:#ffd400;border-color: #ffd400;color:#000000;}
        }
    }
}
</style>